import SortingButtonView from "../../../sorting/view/sorting-button.js";

export default class SortingButton extends SortingButtonView {
  constructor(element, index) {
    super(element, index);
  }

  isActive() {
    return this._element.classList.contains(`${this._element.classList[0]}_active`);
  }
}
